import { v4 } from 'uuid';
export const UUID_VERSION = '4';
/**
 * Generates a new v4 uuid
 */
export function generateUuid() {
    return v4();
}
